<template>
    <div class="box">
        <div class="box-body">
            <div class="row">
                <div class="col-md-12 text-right">
                    <div class="btn-group">
                        <button type="button" class="btn btn-default">Esporta selezionati</button>
                        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                                aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" role="menu">
                            <li><a v-on:click="doExport('excel')">Excel</a></li>
                            <li><a v-on:click="doExport('doc')">Doc</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <br/>
            <v-server-table url="" :columns="columns" :options="options" name="funds" ref="funds"
                            @loading="toggleLoading" @loaded="toggleLoading" @row-click="showFund">
                <template slot="id" slot-scope="props">
                    <div>
                        <input type="checkbox" :value="props.row.id" v-model="selected" v-on:click.stop=""/>
                    </div>
                </template>
                <template slot="denominazione" slot-scope="props">
                    <div>
                        <strong>{{ props.row.denominazione }}</strong>
                    </div>
                </template>
                <template slot="identificativo" slot-scope="props">
                    <div>
                        <strong>{{ props.row.identificativo }}</strong>
                    </div>
                </template>
                <template slot="acquisizione_data" slot-scope="props">
                    <div>
                        {{ props.row.acquisizione_data | dateFormatBase }}
                    </div>
                </template>
                <template slot="acquisizione_tipo" slot-scope="props">
                    <div>
                        {{ props.row.acquisizione_tipo | decodeValue('_dDonationTypes') }}
                    </div>
                </template>
                <template slot="formati" slot-scope="props">
                    <ul>
                        <li v-for="formato in props.row.filmFormats.data">
                            {{ formato.name }}
                        </li>
                    </ul>
                </template>
                <template slot="digitalizzazione" slot-scope="props">
                    <div class="text-center">
                                    <span class="label label-success" v-if="props.row.digitalizzazione === 'sì'">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-warning" v-if="props.row.digitalizzazione === 'parziale'">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-danger" v-if="props.row.digitalizzazione === 'no'">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
                    </div>
                </template>
                <template slot="catalogazione" slot-scope="props">
                    <div class="text-center">
                                    <span class="label label-success" v-if="props.row.catalogazione === 'sì'">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-warning" v-if="props.row.catalogazione === 'parziale'">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-danger" v-if="props.row.catalogazione === 'no'">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
                    </div>
                </template>
                <template slot="intervista" slot-scope="props">
                    <div class="text-center">
                                    <span class="label label-success" v-if="props.row.intervista === 1">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-warning" v-if="props.row.intervista === 2">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
                        <span class="label label-danger"
                              v-if="props.row.intervista === 0 || props.row.intervista === null">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
                    </div>
                </template>
                <template slot="updated_at" slot-scope="props">
                    <div>
                        {{ props.row.updated_at | dateFormatBase }}
                    </div>
                </template>
                <template slot="actions" slot-scope="props">
                    <div>
                        <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)"
                                v-if="$accessControl.isOperator($store.state.profile.profile)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </template>
            </v-server-table>
        </div>
        <!-- /.box-body -->
        <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>
</template>

<script>
  import fundsApi from '../../api/funds'

  export default {
    name: 'FundsTab',
    props: {
      requestFunction: Function
    },
    data () {
      return {
        columns: [
          'id', 'denominazione', 'identificativo', 'acquisizione_data', 'acquisizione_tipo', 'consistenza', 'formati', 'digitalizzazione', 'catalogazione', 'intervista', 'updated_at', 'actions'
        ],
        options: {
          headings: {
            'acquisizione_data': 'Data acquisizione',
            'acquisizione_tipo': 'Tipologia acquisizione',
            'updated_at': 'Ultima modifica'
          },
          sortable: [
            'denominazione', 'acquisizione_data', 'acquisizione_tipo', 'consistenza', 'digitalizzazione', 'catalogazione', 'intervista'
          ],
          requestFunction: this.$props.requestFunction
        },
        loading: false,
        selected: []

      }
    },
    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          fundsApi.delete(id)
            .then((response) => {
              this.$refs.funds.refresh()
              toastr.success('Il fondo è stato rimosso correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        this.loading = !this.loading
      },
      showFund (row) {
        this.$router.push({name: 'fundsShow', params: {id: row.row.id}})
      },
      refresh () {
        this.$refs.funds.refresh()
      },
      doExport (type) {
        this.loading = true
        fundsApi.export(type, this.selected)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            let filename = ''
            let disposition = response.headers['content-disposition']
            if (disposition && disposition.indexOf('attachment') !== -1) {
              let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              let matches = filenameRegex.exec(disposition)
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '')
              }
            }
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            this.loading = false
          })
          .catch((response) => {
            this.loading = false
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/components/FundsTab.vue